import { Box, Divider, Typography } from '@mui/material'

const Footer = () => {
  return (
    <Box component="footer" sx={{ mt: 'auto' }}>
      <Divider />
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          px: { xs: 2, md: 4 },
          py: 2,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          Controle de Produção RFID
        </Typography>
        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} Bihands
        </Typography>
      </Box>
    </Box>
  )
}

export default Footer
